import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

@LazyClientConfig({ key: 'vnGoogleAnalytics', product: ClientConfigProductName.HOST })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: trackingConfigFactory,
})
export class GoogleAnalyticsConfig extends LazyClientConfigBase {
    measurementId: string;
    gaCookieClientIdRegex: string;
    gaCookieSessionIdRegex: string;
    trackEventsTimeoutInMilliseconds: number;
}

export function trackingConfigFactory(service: LazyClientConfigService) {
    return service.get(GoogleAnalyticsConfig);
}
